import { ColorTranslator } from "colortranslator";
export const MuiBackdropTheme = (dt) => {
    const bgColor = new ColorTranslator(dt.color.onSurface.key);
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                backgroundColor: bgColor.setA(dt.opacity[50]).HEXA,
            },
            invisible: {
                backgroundColor: "transparent",
            },
        },
    };
};
